import { render, staticRenderFns } from "./AuthorizeSJ.vue?vue&type=template&id=05e924e4&scoped=true"
import script from "./AuthorizeSJ.vue?vue&type=script&lang=ts"
export * from "./AuthorizeSJ.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e924e4",
  null
  
)

export default component.exports